export function filingPaid(filing:any):boolean {
 return filing?.status==='PAID' && Array.isArray(filing.lines) && filing.lines.length>0 && filing.lines.every((line:any)=>line?.status==='PAID' && (typeof line.balance==='number'?line.balance===0:typeof line.balance==='string'&&/^0+(\.0+)?$/.test(line.balance.trim())));
}
